import { Search } from "lucide-react";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const SearchInput = ({
  setSearchText,
  searchText,
}: {
  setSearchText: Dispatch<SetStateAction<string>>;
  searchText: string;
}) => {
  const [gotAnInput, setGotAnInput] = useState(false);
  const [inputText, setInputText] = useState(searchText || "");
  const [showText, setShowText] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (inputText.length <= 3) {
      if (inputText.length === 0) {
        setSearchText("");
        setShowText(false);
        // Remove search param when empty
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("textSearch");
        setSearchParams(newParams);
      } else {
        const timer = setTimeout(() => {
          setShowText(true);
        }, 500);
        return () => clearTimeout(timer);
      }
      return;
    }
    const timer = setTimeout(() => {
      setSearchText(inputText);
      // Add search param when text is valid
      const newParams = new URLSearchParams(searchParams);
      newParams.set("textSearch", inputText);
      setSearchParams(newParams);
    }, 500);

    setShowText(false);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gotAnInput, setSearchText, searchParams, setSearchParams]);

  return (
    <div className="min-w-40">
      <div className="flex gap-3 bg-white items-center rounded-2xl px-3 py-2 shadow-sm text-[#888] text-sm">
        <Search />
        <input
          placeholder="Suchen..."
          className="border-none outline-none w-full"
          onChange={(e) => {
            setGotAnInput((prev) => !prev);
            setInputText(e.target.value);
          }}
          value={inputText}
        />
      </div>
      {showText && <p className="text-sm absolute text-red-500">Gib mindestens 4 Zeichen ein</p>}
    </div>
  );
};

export default SearchInput;
